import PropTypes from 'prop-types';
import React from 'react';

import { NavigationLoginBase, NavigationLoginItem, NavigationLoginItemButton } from './styled.js';
import { Button } from '../common/button';

const NavigationLogin = ({ dark }) => (
  <nav>
    <NavigationLoginBase>
      <NavigationLoginItem
        dark={dark}
      >
        <a href="https://app.ludus.one/login?ref=header">
          Login
        </a>
      </NavigationLoginItem>
      <NavigationLoginItemButton
        dark={dark}
      >
        <Button href="https://app.ludus.one/signup">Try for free</Button>
      </NavigationLoginItemButton>
    </NavigationLoginBase>
  </nav>
)

NavigationLogin.propTypes = {
  dark: PropTypes.bool
}

NavigationLogin.defaultProps = {
}

export default NavigationLogin
